import * as React from "react";
import clsx from "clsx";
const SkeletonItem = (props) => {
  const { className, width, height } = props;
  return /* @__PURE__ */ React.createElement("span", { className: clsx("skeleton__item", className), style: { width, height } }, "‌");
};
export {
  SkeletonItem
};
